import React from "react";

// react-bootstrap components
import { Container } from "react-bootstrap";
import { properties } from "../../config/ClientConfigurations";

function HipposAdminFooter() {
  return (
    <>
      <footer className="footer">
        <Container fluid className="pl-4 ml-2">
          <nav>
            <p className="copyright text-center">
              © {new Date().getFullYear() + " "}
              <a target="_blank" href="https://wlabel.gr">
                {properties.companyName}
              </a>
            </p>
          </nav>
        </Container>
      </footer>
    </>
  );
}

export default HipposAdminFooter;
